import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD66_bKJ6ECu9DtR0we9r0eiPvVDv6FQtM",
  authDomain: "teamo-5ce63.firebaseapp.com",
  projectId: "teamo-5ce63",
  storageBucket: "teamo-5ce63.firebasestorage.app",
  messagingSenderId: "347712079938",
  appId: "1:347712079938:web:5657a34b95d315716105db"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
